<template>
    <div
        :class="[
      'page-break-item',
      'form-item',
      `align-${align || 'center'}`,
      { 'selected': isSelected }
    ]"
        @click="$emit('select-item', item)"
    >
        <div :class="['navigation-buttons', `justify-${align || 'center'}`]">
            <button
                v-if="showPreviousButton"
                class="nav-button prev-button"
                type="button"
                disabled
            >
                <i class="md-icon">arrow_back</i>
                {{ previousButtonText || "Geri" }}
            </button>

            <button
                v-if="showNextButton"
                class="nav-button next-button"
                type="button"
                disabled
            >
                {{ nextButtonText || "Devam" }}
                <i class="md-icon">arrow_forward</i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageBreak",
    props: {
        item: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            default: "center",
        },
        nextButtonText: {
            type: String,
            default: "Devam",
        },
        previousButtonText: {
            type: String,
            default: "Geri",
        },
        showPreviousButton: {
            type: Boolean,
            default: true,
        },
        showNextButton: {
            type: Boolean,
            default: true,
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page-break-item {
    padding: 15px;
    margin: 10px 0;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #3b82f6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    &.selected {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
}

.navigation-buttons {
    display: flex;
    gap: 12px;

    &.justify-left {
        justify-content: flex-start;
    }

    &.justify-center {
        justify-content: center;
    }

    &.justify-right {
        justify-content: flex-end;
    }
}

.nav-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: #3b82f6;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: not-allowed;
    opacity: 0.8;
    transition: all 0.2s ease;

    .md-icon {
        font-size: 16px;
    }

    &.prev-button {
        background-color: #6b7280;
    }

    &.next-button {
        background-color: #3b82f6;
    }
}
</style>
